import { render, staticRenderFns } from "./InvScL.vue?vue&type=template&id=4e40c2e0"
import script from "./InvScL.vue?vue&type=script&lang=js"
export * from "./InvScL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports